/*
 *
 * CreateSafePasswordModal
 *
 * @version 1.0.0
 * @author Mauro La Barbera
 * @since 01-Aug-2025
 */
import React from 'react'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import Toggle from 'Hoc/ToggleComponent'
import PropTypes from 'prop-types'
import DataRow from 'Components/DataRow'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import formattedMessage from './languageModule'

const CreateSafePasswordModal = (props) => (
  <Toggle>
    <MerchantModal
      title={formattedMessage.modalTitle}
      customAnalyticsDescription={formattedMessage.introText}
      withoutButton
      onClose={() => props.actions.doHidePopup()}
      topBarTitle=' '
    >
      <div className='pciModalContent'>
        <MerchantGenericCard>
          <div className='pciModalContentHeader'>
            <DataRow full label={formattedMessage.protectionLabel} content={formattedMessage.protectionValue} />
            <DataRow full label={formattedMessage.difficultyLabel} content={formattedMessage.difficultyValue} />
          </div>
        </MerchantGenericCard>
        <div className='pciModalContentValidity'>
          <p className='pciModalContentValidityText'>{formattedMessage.validForLabel}</p>
          <div className='pciModalContentValidityBadges'>
            <MerchantTableBadge symbol label={formattedMessage.ecommerceLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.motoLabel} status='brand' />
            <MerchantTableBadge symbol label={formattedMessage.faceToFaceLabel} status='brand' />
          </div>
        </div>
        <MerchantGenericCard>
          {formattedMessage.introText}
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>{formattedMessage.setPasswordTitle}</h1>
            <div>
              {formattedMessage.passwordCriteriaIntro}
              <ul>
                <li>{formattedMessage.passwordCriteriaAlphanumeric}</li>
                <li>{formattedMessage.passwordCriteriaLength}</li>
                <li>{formattedMessage.passwordCriteriaUppercase}</li>
                <li>{formattedMessage.passwordCriteriaSpecial}</li>
              </ul>
            </div>
            <div>
              {formattedMessage.passwordTipsIntro}
              <ul>
                <li>{formattedMessage.passwordTipsNoPersonalData}</li>
                <li>{formattedMessage.passwordTipsDifficult}</li>
                <li>{formattedMessage.passwordTipsNoDefault}</li>
                <li>{formattedMessage.passwordTipsNoSave}</li>
                <li>{formattedMessage.passwordTipsNoTogether}</li>
              </ul>
            </div>
          </div>
          <div className='pciModalContentSection'>
            <h1 className='pciModalContentSectionTitle'>{formattedMessage.changePasswordTitle}</h1>
            <div>{formattedMessage.changePasswordText}</div>
          </div>
        </MerchantGenericCard>
      </div>
    </MerchantModal>
  </Toggle>
)

CreateSafePasswordModal.propTypes = {
  actions: PropTypes.object
}

CreateSafePasswordModal.defaultProps = {
  action: {}
}

export default CreateSafePasswordModal
